import React from 'react';
import PropTypes from 'prop-types';
import Section from '../../../utils/section/Section';
import I18n from '../../../config/i18n';
import { Row, Col } from '../../../utils/grid/Grid';
import Image from '../../../utils/Image';
import Fa from '../../../utils/Fa';

import aboutData from '../static/aboutData';

import './about.css';

const AboutItem = ({ ...props }) => (
  <div className="about-box">
    <div className="about-box-icon">
      <Fa icon={props.icon} />
    </div>
    <h3 className="about-box-headline">{props.headline}</h3>
    <p className="about-box-content">{props.content}</p>
    <ul className="about-box-list">
      {props.list.map((listElem, i) => (
        <li className="about-box-list-item" key={i}>
          {listElem.content}
        </li>
      ))}
    </ul>
  </div>
);

AboutItem.propTypes = {
  icon: PropTypes.string.isRequired,
  headline: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.string,
    }),
  ).isRequired,
};

const TeamItem = ({ ...props }) => (
  <div className="about-team-item">
    <img
      className="about-team-item-image"
      src={props.image}
      srcSet={`${props.image2x} 2x`}
      alt={props.name}
      role="presentation"
    />
    <div className="about-team-item-text">
      <strong>{props.name}</strong>
      {props.position}
    </div>
  </div>
);

TeamItem.propTypes = {
  image: PropTypes.string.isRequired,
  image2x: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
};

const About = () => (
  <div>
    <Section headline={I18n.t('your_benefits.h1')}>
      <Row className="about-header">
        <Col xs={12}>
          <p>
            {I18n.t('your_benefits.p1_1')}
            <br />
            {I18n.t('your_benefits.p1_2')}
          </p>
        </Col>
      </Row>
      <Row className="about-content" center="xs">
        {aboutData.benefits().map((aboutItem, index) => (
          <Col xs={12} sm={6} md={4} key={index} className="about-item">
            <AboutItem {...aboutItem} />
          </Col>
        ))}
      </Row>
    </Section>
    <Section border headline={I18n.t('your_benefits.contact.headline')}>
      <Row className="about-contact-header">
        <Col xs={12}>
          <p>{I18n.t('your_benefits.contact.intro')}</p>
        </Col>
      </Row>
      <Row className="about-contact-content" center="xs">
        {aboutData.contactLanguages.map((locale) => (
          <Col className="about-contact-content-item" xs={12} sm={6} md={4} key={locale}>
            <span className="about-contact-content-number">
              {I18n.t(`your_benefits.contact.${locale}.number`)}
            </span>
            {I18n.t(`your_benefits.contact.${locale}.text`)}
          </Col>
        ))}
      </Row>
      <Row className="about-contact-footer" center="xs">
        <Col xs={12} sm={6} md={4}>
          <a
            className="about-contact-footer-mail"
            href={`mailto:${I18n.t('your_benefits.contact.email_link')}`}
          >
            {I18n.t('your_benefits.contact.email')}
          </a>
          <p className="about-contact-footer-content">
            {I18n.t('your_benefits.contact.opening_hours')}
            <br />
            {I18n.t('your_benefits.contact.opening_hours_1')}
          </p>
        </Col>
      </Row>
    </Section>
    <Section border className="about-team" headline={I18n.t('your_benefits.headline_html')}>
      <p>{I18n.t('your_benefits.intro')}</p>
      <Row center="xs">
        {aboutData.team().map((teamItem, index) => (
          <Col xs={6} sm={4} md={3} lg={2} key={index}>
            <TeamItem {...teamItem} />
          </Col>
        ))}
      </Row>
    </Section>
    <Section className="about-partners" headline={I18n.t('your_benefits.contact.partners')}>
      <Row center="xs" middle="xs">
        <Col>
          <Image src={aboutData.partners.ogone} alt={I18n.t('your_benefits.contact.partners')} />
        </Col>
        <Col>
          <Image
            src={aboutData.partners.actionFun}
            alt={I18n.t('your_benefits.contact.partners')}
          />
        </Col>
      </Row>
    </Section>
  </div>
);

export default About;
